import { z } from "zod";
import { StableUuidSchema } from "./identifiers.js";
import { UtcTimestampSchema } from "./time.js";
export const AuthenticatedPrincipalSchema = z
    .object({
    id: StableUuidSchema,
    issuer: z.string().url().max(2048),
    subject: z.string().min(1).max(512),
    displayName: z.string().min(1).max(200).nullable(),
    enabled: z.boolean(),
    authorizationRevision: z.number().int().nonnegative(),
    sessionRevision: z.number().int().nonnegative(),
})
    .strict();
export const HumanSessionSchema = z
    .object({
    principal: AuthenticatedPrincipalSchema,
    authenticatedAt: UtcTimestampSchema,
    expiresAt: UtcTimestampSchema,
    admissionCheckedAt: UtcTimestampSchema,
})
    .strict();
export const PrincipalStateMutationSchema = z
    .object({
    expectedAuthorizationRevision: z.number().int().nonnegative(),
    reason: z.string().trim().min(8).max(500),
    idempotencyKey: z.string().min(16).max(128),
})
    .strict();
export const PrincipalMutationResultSchema = z
    .object({
    principal: AuthenticatedPrincipalSchema,
    replayed: z.boolean(),
})
    .strict();
//# sourceMappingURL=auth.js.map